export default __webpack_public_path__ + "static/media/icon-snappy-process.eea91882.svg";